<template>
	<div class="mixedcells">
		<PageBanner></PageBanner>
		<div class="tt mc_title">
			<span class="mc_eng_title">MIXED CELLS</span> 病毒分离培养混合细胞
		</div>
		<SectionDivider class="progress tt"></SectionDivider>
		<div class="mc_container">
			<img src="../assets/img/index/黄色背景图3.jpg" class="y_img3" />
			<div class="hero_text">
				<p class="p1">新一代病毒分离培养工具</p>
				<p class="p2">MIXED CELLS</p>
				<p class="p3">康和达混合细胞由不同细胞系按特定比例预混而成，<br>
					即用型设计，从细胞准备到病毒接种仅需2～3h。<br>
					省去传统复苏与传代，提升检出率、降低工作量、节省总成本！</p>
			</div>
			<img src="../assets/img/production/MixedCells_2.png" class="mc_img" />
		</div>
		<p class="exp3">康和达混合细胞由不同细胞系按特定比例预混而成，即用型设计，
			从细胞准备到病毒接种仅需2～3h。省去传统复苏与传代，
			提升检出率、降低工作量、节省总成本！</p>

		<!-- ===== 产品类型 ===== -->
		<div class="tt section_head">
			<img src="../assets/img/production/图标1.png" class="icon1" />
			<p class="section_name">产品类型</p>
		</div>
		<div class="cards">
			<div class="type_card">
				<div class="type_head">
					<span class="dot">·</span> 呼吸道病毒专用
				</div>
				<p class="type_sub">呼吸道病毒分离用混合细胞 —— 呼吸道病毒的分离培养</p>
				<div class="type_item">
					<p class="item_label">① 产品定义</p>
					<p class="item_text">由不同细胞系按特定比例预混而成，是一款即用型、高稳定性的细胞产品。</p>
				</div>
				<div class="type_item">
					<p class="item_label">② 设计理念</p>
					<p class="item_text">结合传统单一细胞系稳定性与模拟人体微环境的特性，优势互补，实现对多种呼吸道病毒的高效捕获与扩增。</p>
				</div>
				<div class="type_item">
					<p class="item_label">③ 预期用途</p>
					<p class="item_text">广泛用于甲/乙型流感、副流感病毒、腺病毒等的分离与培养。</p>
				</div>
			</div>
			<div class="type_card">
				<div class="type_head">
					<span class="dot">·</span> 肠道病毒专用
				</div>
				<p class="type_sub">肠道病毒分离用混合细胞 —— 手足口病毒的分离培养</p>
				<div class="type_item">
					<p class="item_label">① 产品定义</p>
					<p class="item_text">由不同细胞系按特定比例预混而成的即用型细胞产品，无需繁琐操作，开箱即用。</p>
				</div>
				<div class="type_item">
					<p class="item_label">② 设计理念</p>
					<p class="item_text">可以高效捕获EV71、CVA16；并高效识别CVA4、CVA6、CVA10等其他柯萨奇A组病毒，完美解决了传统单一细胞对部分病毒敏感性低的痛点。</p>
				</div>
				<div class="type_item">
					<p class="item_label">③ 预期用途</p>
					<p class="item_text">专用于肠道病毒，特别是手足口病相关病毒（柯萨奇病毒CVA系列、EV71）的分离培养与鉴定。</p>
				</div>
			</div>
		</div>

		<div class="tt custom_head">定制服务</div>
		<div class="cards">
			<div class="custom_card">
				<p class="item_label">① 定制细胞系</p>
				<p class="item_text">如果您有特定的细胞系需求，我们可以为您提供定制化的细胞产品，精准匹配您的实验要求。</p>
			</div>
			<div class="custom_card">
				<p class="item_label">② 其他病毒分离需求</p>
				<p class="item_text">如果您有分离其他类型的病毒的需求，我们的专业研发团队可以与您深度合作，共同开发针对性的新细胞产品，助力您实现高效分离。</p>
			</div>
		</div>

		<!-- ===== 主要特点 ===== -->
		<div class="tt section_head">
			<img src="../assets/img/production/图标1.png" class="icon1" />
			<p class="section_name">主要特点</p>
		</div>
		<p class="tt maintext">低载量样本分离优势</p>
		<p class="tt subtext">在病毒载量较低的样本中（核酸检测 Ct 值 ≥ 30），传统细胞分离效率显著下降，而呼吸道病毒分离用混合细胞表现出卓越的分离性能：</p>
		<div class="cards data_cards">
			<div class="data_card" v-for="item in lowLoadData" :key="item.subtype">
				<div class="data_title">{{ item.subtype }} 亚型分离数据</div>
				<div class="data_row">
					<div class="data_cell highlight">
						<p class="cell_label">混合细胞</p>
						<p class="cell_value">{{ item.mixed }}</p>
					</div>
					<div class="data_cell">
						<p class="cell_label">传统 SUS-MDCK 细胞</p>
						<p class="cell_value">{{ item.classic }}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="tt note">
			<span class="note_label">研究结论</span>
			呼吸道病毒分离用混合细胞能有效解决传统方法对低载量样本分离困难的痛点，极大提升了样本的有效利用率，是流感监测工作中不可或缺的有力工具。
		</div>

		<p class="tt maintext">总体效能与亚型优势</p>
		<p class="tt subtext">数据表明混合细胞对乙型流感（BV）的分离效果具有显著统计学差异（P&lt;0.05），是临床分离的优选方案。</p>
		<div class="cards">
			<div class="total_card">
				<div class="data_title">总体分离阳性率对比</div>
				<div class="data_row">
					<div class="data_cell highlight">
						<p class="cell_value big">71.35%</p>
						<p class="cell_label">混合细胞</p>
					</div>
					<div class="data_cell">
						<p class="cell_value big">64.33%</p>
						<p class="cell_label">传统 SUS-MDCK 细胞</p>
					</div>
				</div>
				<div class="conclusion">结论：总体分离效能显著提升，优势明显</div>
			</div>
			<div class="total_card">
				<div class="data_title">按病毒亚型细分统计</div>
				<el-table :data="subtypeData" border stripe
					:header-cell-style="{'text-align':'center','height':'50px','backgroundColor':'#fff00699','color':'rgb(35, 24, 21)'}"
					:cell-style="{'text-align':'center','height':'50px'}" style="width: 100%;">
					<el-table-column prop="subtype" label="病毒亚型" min-width="24%"></el-table-column>
					<el-table-column prop="mixed" label="混合细胞" min-width="24%"></el-table-column>
					<el-table-column prop="classic" label="传统方法" min-width="24%"></el-table-column>
					<el-table-column prop="pvalue" label="P值（差异）" min-width="28%"></el-table-column>
				</el-table>
				<div class="conclusion">显著优势：对乙型流感（BV）的分离率提升具有统计学意义</div>
			</div>
		</div>

		<div class="tt section_head" style="margin-top: 10vh;">
			<img src="../assets/img/production/图标1.png" class="icon1" />
			<p class="section_name small">更多产品信息</p>
		</div>
		<p class="tt subtext" style="margin-bottom: 10vh;text-indent: 2em;">想了解更多产品信息请关注下方官网微信公众号、视频号。</p>
	</div>
</template>

<script>
	import PageBanner from '../components/public/PageBanner.vue'
	import SectionDivider from '../components/public/SectionDivider.vue'
	import scrollReveal from '../mixins/scrollReveal'
	export default {
		name: 'MixedCells',
		components: {
			PageBanner,
			SectionDivider
		},
		mixins: [scrollReveal],
		revealSelectors: ".mc_container, .cards",
		data() {
			return {
				// 低载量样本（Ct ≥ 30）分离数据
				lowLoadData: [{
					subtype: 'H1N1',
					mixed: '60.00%',
					classic: '26.67%'
				}, {
					subtype: 'BV（乙型流感）',
					mixed: '50.00%',
					classic: '25.00%'
				}],
				// 按病毒亚型细分统计
				subtypeData: [{
					subtype: 'H3N2',
					mixed: '79.03%',
					classic: '72.58%',
					pvalue: '0.513'
				}, {
					subtype: 'H1N1',
					mixed: '68.33%',
					classic: '61.67%',
					pvalue: '0.066'
				}, {
					subtype: 'BV（乙流）',
					mixed: '65.31%',
					classic: '57.14%',
					pvalue: '0.011*'
				}]
			}
		}
	}
</script>

<style scoped>
	/* 与其它产品页一致的 1200px 内容区左对齐基准 */
	.tt {
		margin-left: calc(50% - 600px);
	}

	.maintext {
		font-size: 30px;
		font-weight: 700;
		margin-top: 10vh;
	}

	.subtext {
		font-size: 18px;
		line-height: 2;
	}

	.mc_container {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		transform: translateY(200px);
		transition: transform .5s ease, opacity .5s ease;
		opacity: 0;
	}

	.y_img3 {
		margin-top: 20px;
		height: 400px;
		width: 1200px;
	}

	/* 三行文案作为一个整体左对齐，块的左边距 1200px 底图左缘 80px */
	.hero_text {
		position: absolute;
		top: 50%;
		left: calc(50% - 520px);
		transform: translateY(-50%);
	}

	.hero_text p {
		margin: 0;
	}

	.hero_text .p1 {
		font-size: 28px;
	}

	.hero_text .p2 {
		margin-top: 10px;
		font-size: 50px;
		font-family: Rany Bold;
		font-weight: 700;
	}

	.hero_text .p3 {
		margin-top: 30px;
		font-size: 18px;
		line-height: 2;
	}

	/* 产品图为 2.1:1 的横图，用 left+translateX 定位到 1200px 底图的右半区，避免溢出 */
	.mc_img {
		position: absolute;
		width: auto;
		height: 220px;
		left: 50%;
		transform: translateX(80px);
	}

	.mc_title {
		font-size: 2em;
		margin-top: 6vh;
		letter-spacing: 1px;
	}

	.mc_eng_title {
		font-family: Rany;
		font-weight: 600;
		font-size: 30px;
	}

	.progress {
		width: 200px;
		margin-top: 10px;
		margin-bottom: 5vh;
	}

	.exp3 {
		display: none;
	}

	.icon1 {
		width: 33px;
		height: auto;
	}

	.section_head {
		display: flex;
		align-items: center;
		margin-top: 10vh;
	}

	.section_name {
		font-size: 30px;
		font-weight: 500;
		margin-left: 10px;
	}

	.section_name.small {
		font-size: 25px;
		font-weight: bold;
	}

	/* ===== 卡片区 ===== */
	.cards {
		display: flex;
		justify-content: center;
		align-items: stretch;
		gap: 40px;
		width: 1200px;
		margin: 3vh auto 0;
		transform: translateY(200px);
		transition: transform .5s ease, opacity .5s ease;
		opacity: 0;
	}

	/* 进场动画的终态，必须写在 .mc_container / .cards 之后才能覆盖它们的初始 transform 与 opacity */
	.content-center {
		transform: translateY(0);
		opacity: 1;
	}

	.type_card, .custom_card, .total_card {
		flex: 1;
		min-width: 0;
		background-color: #fafafa;
		border-top: 4px solid #fff100;
		border-radius: 5px;
		box-shadow: 0 2px 12px rgba(35, 24, 21, .08);
		padding: 25px 30px 30px;
		box-sizing: border-box;
	}

	.type_head {
		font-size: 24px;
		font-weight: bold;
		color: rgb(35, 24, 21);
	}

	.dot {
		color: #e5d800;
		font-weight: 600;
	}

	.type_sub {
		font-size: 16px;
		color: #666;
		margin-top: 8px;
		padding-bottom: 15px;
		border-bottom: 1px solid #e6e6e6;
	}

	.type_item {
		margin-top: 18px;
	}

	.item_label {
		font-size: 18px;
		font-weight: bold;
		color: rgb(35, 24, 21);
	}

	.item_text {
		font-size: 16px;
		line-height: 1.9;
		margin-top: 6px;
	}

	.custom_head {
		font-size: 25px;
		font-weight: bold;
		margin-top: 8vh;
	}

	/* ===== 数据展示 ===== */
	.data_cards {
		margin-top: 4vh;
	}

	.data_card {
		flex: 1;
		min-width: 0;
		background-color: #fff;
		border-radius: 5px;
		box-shadow: 0 2px 12px rgba(35, 24, 21, .1);
		padding: 25px 30px 30px;
		box-sizing: border-box;
	}

	.data_title {
		font-size: 20px;
		font-weight: bold;
		color: rgb(35, 24, 21);
		margin-bottom: 20px;
	}

	.data_row {
		display: flex;
		gap: 20px;
	}

	.data_cell {
		flex: 1;
		background-color: #f5f5f5;
		border-radius: 5px;
		padding: 18px 10px;
		text-align: center;
	}

	.data_cell.highlight {
		background-color: rgba(255, 241, 0, .25);
	}

	.cell_label {
		font-size: 16px;
		color: #666;
	}

	.cell_value {
		font-size: 26px;
		font-weight: bold;
		margin-top: 8px;
	}

	.cell_value.big {
		font-size: 40px;
		margin-top: 0;
		margin-bottom: 8px;
	}

	.data_cell.highlight .cell_value {
		color: #c9a800;
	}

	.conclusion {
		margin-top: 20px;
		background-color: #f7f7f7;
		border-left: 4px solid #fff100;
		border-radius: 3px;
		padding: 12px 15px;
		font-size: 16px;
		color: rgb(35, 24, 21);
	}

	.note {
		width: 1200px;
		box-sizing: border-box;
		margin-top: 4vh;
		background-color: #f7f7f7;
		border-left: 4px solid #fff100;
		border-radius: 3px;
		padding: 18px 20px;
		font-size: 16px;
		line-height: 2;
	}

	.note_label {
		font-weight: bold;
		margin-right: 8px;
	}

	@media screen and (max-width: 1300px) {
		.cards, .note {
			width: auto;
			margin-left: 30px;
			margin-right: 30px;
		}
	}

	@media screen and (max-width: 1150px) {
		.tt {
			margin-left: calc(50% - 450px);
		}

		.y_img3 {
			margin-top: 20px;
			height: auto;
			width: 100%;
		}

		.hero_text {
			left: 7%;
		}

		.hero_text .p1 {
			font-size: 1.5rem;
		}

		.hero_text .p2 {
			font-size: 2rem;
		}

		.hero_text .p3 {
			font-size: 1rem;
			margin-top: 20px;
		}

		.mc_img {
			width: auto;
			height: 180px;
			transform: translateX(30px);
		}

		/* 与 .tt 的 calc(50% - 450px) 缩进对齐 */
		.cards, .note {
			width: 900px;
			max-width: calc(100% - 60px);
			margin-left: auto;
			margin-right: auto;
		}

		.cards {
			gap: 25px;
		}
	}

	@media screen and (max-width: 800px) {
		.tt {
			margin-left: calc(50% - 180px);
		}

		.maintext {
			font-size: 25px;
		}

		.mc_title {
			font-size: 1.1rem;
			margin-top: 5vh;
		}

		.mc_eng_title {
			font-weight: 500;
			font-size: 1.1rem;
		}

		.progress {
			width: 120px;
			margin-top: 10px;
		}

		.y_img3 {
			margin-top: 20px;
			height: calc(180px + 10vw);
			width: 100%;
		}

		.hero_text {
			left: 6%;
		}

		.hero_text .p1, .hero_text .p2 {
			font-size: 1.2rem;
		}

		.hero_text .p2 {
			margin-top: 5px;
		}

		.hero_text .p3 {
			display: none;
		}

		.exp3 {
			display: block;
			margin-right: 30px;
			margin-left: 30px;
			font-size: 1rem;
			line-height: 2;
			text-indent: 2em;
		}

		.mc_img {
			position: absolute;
			height: 100px;
			width: auto;
			margin-top: 45px;
			transform: translateX(10px);
		}

		.icon1 {
			width: 25px;
			height: auto;
		}

		.subtext {
			margin-right: 20px;
			line-height: 2rem;
		}

		/* 移动端卡片改为单列纵向排列 */
		.cards {
			flex-direction: column;
			margin-left: 20px;
			margin-right: 20px;
			gap: 20px;
		}

		.note {
			margin-left: 20px;
			margin-right: 20px;
		}

		.type_card, .custom_card, .total_card, .data_card {
			padding: 20px;
		}

		.type_head {
			font-size: 20px;
		}

		.data_row {
			gap: 12px;
		}

		.cell_value {
			font-size: 22px;
		}

		.cell_value.big {
			font-size: 30px;
		}
	}
</style>
